var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/*
 * @Author: yejianfei
 * @Date: 2023-04-03 22:34:45
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-17 10:59:52
 * @Description:
 * @Developer:
 */
import React from 'react';
import AdminPage from '../../components/antd/AdminPage';
import { Button, Card, Input, Space } from 'antd';
import APITable from '../../components/antd/APITable';
import WithRouter from '../../components/WithRouter';
import InputTags from '../../components/antd/APITags';
import Api from '../../api';
let AdminQuestionFormPage = class AdminQuestionFormPage extends React.Component {
    constructor() {
        super(...arguments);
        this.api = Api();
        this.state = {
            items: []
        };
    }
    componentDidMount() {
        this.init();
    }
    init() {
        this.setState({ items: new Array(1).fill({}).map((item, index) => ({
                id: `${index}`,
                title: '',
                options: []
            })) });
    }
    reset(items) {
        console.log('items', items);
        let index = items.findIndex(item => !item.title && item.options.length === 0);
        if (index !== -1) {
            this.setState({ items });
            return;
        }
        items.push({
            id: `${items.length}`,
            title: '',
            options: []
        });
        this.setState({ items });
    }
    submit() {
        this.api.post('/admin/questions/batch', {
            questions: this.state.items
        }).then(res => {
            this.props.route.navigate(-1);
        }).catch(err => {
            console.log('err', err);
        });
    }
    render() {
        return (React.createElement(AdminPage, null,
            React.createElement(Card, { title: '\u6279\u91CF\u65B0\u589E\u95EE\u9898', size: 'small', style: { height: '100%' }, bodyStyle: { padding: 12, height: 'calc(100% - 39px)',
                    overflow: 'hidden' }, extra: React.createElement(Space, null,
                    React.createElement(Button, { danger: true, size: 'small', type: 'link', onClick: () => this.props.route.navigate(-1), children: '返回' }),
                    React.createElement(Button, { size: 'small', type: 'link', onClick: () => this.submit(), children: '提交' })) },
                React.createElement(APITable, { data: this.state.items, bordered: true, tableLayout: 'fixed', size: 'small', rowKey: 'id', pagination: false, 
                    // scroll={{y: 600}}
                    columns: [{
                            title: '描述',
                            align: 'left',
                            dataIndex: 'title',
                            render: ((text, record, index, instance) => {
                                return (React.createElement(Input, { value: record.title, onChange: (event) => {
                                        const items = [...this.state.items];
                                        items[index].title = event.target.value;
                                        this.reset(items);
                                    } }));
                            })
                        }, {
                            title: '选项',
                            width: 600,
                            align: 'center',
                            dataIndex: 'options',
                            render: ((text, record, index, instance) => {
                                return (React.createElement(InputTags, { value: record.options, onChange: (value) => {
                                        const items = [...this.state.items];
                                        items[index].options = value;
                                        this.reset(items);
                                    } }));
                            })
                        }, {
                            title: '操作',
                            dataIndex: 'operation',
                            align: 'center',
                            width: 200,
                            render: ((text, record, index, instance) => {
                                return (React.createElement(Button, { danger: true, size: 'small', type: 'link', onClick: () => {
                                        const items = [...this.state.items];
                                        items === null || items === void 0 ? void 0 : items.splice(index, 1);
                                        this.reset(items);
                                    }, children: '删除' }));
                            })
                        }] }))));
    }
};
AdminQuestionFormPage = __decorate([
    WithRouter()
], AdminQuestionFormPage);
export default AdminQuestionFormPage;
